import React, { lazy } from "react";
import { Route } from "react-router";

import { LazyRouteElement } from "components/routes/LazyRouteElement";
import Layout from "components/layout/Layout";
import { RouteGuardPublic } from "components/routes/RouteGuardPublic";

const IndexLazy = lazy(() => import("./pages/Index").then(module => ({ default: module.Index })));

export function Routes() {
    return (
        <>
            <Route
                key="invoice-estimator-index"
                path="/invoice-estimator/:lang?"
                element={
                    <RouteGuardPublic >
                        <LazyRouteElement fallback={null}>{<IndexLazy />}</LazyRouteElement>
                    </RouteGuardPublic>
                }
            /> 
        </> 
    )
}

